import React from 'react';
import { Settings } from 'lucide-react';
import { ServiceTierBadge } from '../profiles/ServiceTierBadge';
import { IntelligenceProfile } from '../../types';

interface ServicePackageSectionProps {
  profile: IntelligenceProfile;
  className?: string;
}

export const ServicePackageSection: React.FC<ServicePackageSectionProps> = ({
  profile,
  className = ""
}) => {
  return (
    <div className={`p-3 bg-purple-50 rounded-lg border-l-4 border-l-purple-400 ${className}`}>
      <h4 className="text-sm font-semibold text-purple-900 mb-3 flex items-center">
        <Settings className="h-4 w-4 mr-2" />
        Service Package
      </h4>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <p className="text-xs text-purple-700 mb-2">Service Tier</p>
          <div className="flex items-center gap-2">
            <ServiceTierBadge tierLevel={profile.tier_level} />
          </div>
        </div>
        <div>
          <p className="text-xs text-purple-700 mb-2">Billing Type</p>
          <div className="flex items-center gap-2">
            {profile.billing_type === 'monthly' ? (
              <span className="text-sm flex items-center text-green-700 bg-green-50 px-2 py-1 rounded-md border border-green-200">
                🔄 Monthly Subscription
              </span>
            ) : (
              <span className="text-sm flex items-center text-blue-700 bg-blue-50 px-2 py-1 rounded-md border border-blue-200">
                💳 One-time Payment
              </span>
            )}
          </div>
        </div>
        <div>
          <p className="text-xs text-purple-700 mb-2">Delivery Email</p>
          <div className="flex items-center gap-2">
            <span className="text-sm font-mono text-purple-700 bg-purple-50 px-2 py-1 rounded-md border border-purple-200">
              {profile.delivery_email || profile.email}
            </span>
            {profile.delivery_email && profile.delivery_email !== profile.email && (
              <span className="text-xs text-amber-600 bg-amber-50 px-2 py-1 rounded border border-amber-200">
                Different from profile
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};